import { z } from "zod";
import { paginationResponseType } from "@/types";

// ============ CREATE ============
export type createClientAccountantState = {
    success?: boolean;
    message?: string;
    errors?: {
        clientCode?: string[];
        clientUserName?: string[];
        clientName?: string[];
        observation?: string[];
        accountantId?: string[];
    };
    values?: {
        clientCode: string;
        clientUserName: string;
        clientName: string;
        observation: string;
        accountantId: string;
    };
};

export const createClientAccountantSchema = z.object({
    clientCode: z.string()
        .min(4, { message: "Código deve ter pelo menos 4 caracteres" })
        .max(4, { message: "Código não pode exceder 4 caracteres" }),
    clientUserName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    clientName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    observation: z.string().optional(),
    accountantId: z.uuid("ID do contador deve ser um UUID válido"),
});

export type CreateClientAccountantType = {
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation: string | null;
    accountantId: string;
};

// ============ DELETE ============
export type deleteClientAccountantType = {
    id: string;
    accountantId: string;
};

// ============ GET ============
export type clientAccountantResponseType = {
    id: string,
    client: {
        id: string;
        code: string;
        userName: string | null;
        name: string;
        role: string;
    };
    accountant: {
        id: string;
        code: string;
        userName: string | null;
        name: string;
    };
    observation: string | null,
    createdAt: string,
    updatedAt: string,
};

export const defaultClientAccountant: clientAccountantResponseType = {
    id: '',
    client: {
        id: '',
        code: '',
        userName: '',
        name: '',
        role: ''
    },
    accountant: {
        name: '',
        code: '',
        id: '',
        userName: '',
    },
    observation: '',
    createdAt: '',
    updatedAt: '',
};

export type ClientAccountantResponse = {
    data: clientAccountantResponseType[];
    pagination: paginationResponseType;
};

// ============ UPDATE ============
export type UpdateClientAccountantType = {
    id: string;
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation: string | null;
};

export type UpdateClientAccountantState = {
    success?: boolean;
    message?: string;
    errors?: {
        id?: string[];
        clientCode?: string[];
        clientUserName?: string[];
        clientName?: string[];
        observation?: string[];
    };
    values?: {
        id: string;
        clientCode: string;
        clientUserName: string;
        clientName: string;
        observation: string;
    };
};

export const updateClientAccountantSchema = z.object({
    id: z.uuid(),
    clientCode: z.string()
        .min(4, { message: "Código deve ter pelo menos 4 caracteres" })
        .max(4, { message: "Código não pode exceder 4 caracteres" }),
    clientUserName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    clientName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    observation: z.string().optional(),
});

// ============ TIPOS COMPLETOS ============
export type ClientAccountantType = {
    id: string;
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation: string | null;
    createdAt: string;
    updatedAt: string;
    accountantId: string;
    accountant?: {
        code: string;
        userName: string;
    };
};

export type ClientAccountantsResponse = {
    data: ClientAccountantType[];
    pagination: paginationResponseType;
};

// ============ TIPOS PARA FORMULÁRIOS ============
export type CreateClientAccountantFormData = {
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation?: string;
    accountantId: string;
};

export type UpdateClientAccountantFormData = {
    id: string;
    clientCode?: string;
    clientUserName?: string;
    clientName?: string;
    observation?: string;
    accountantId?: string;
};